<template>
  <!-- 平台管理员人才添加进度1 -->
  <div class="main-css">
    <div class="main-box">
      <!-- 标题部分 -->
      <div class="top-title">{{ $t("humanResourcesPosting") }}</div>
      <!-- 进度条部分 -->
      <div class="progress-bar">
        <div class="line-between-active"></div>
        <div class="progress-item-active">
          1 <span class="progress-title">{{ $t("basicInformation") }}</span>
        </div>
        <div class="line-center-normal"></div>
        <div class="progress-item-normal">
          2<span class="progress-title">{{ $t("careerRequest") }}</span>
        </div>
        <div class="line-center-normal"></div>
        <div class="progress-item-normal">
          3<span class="progress-title">{{ $t("confirm") }}</span>
        </div>
        <div class="line-between-normal"></div>
      </div>
      <!-- 第一行 -->

      <div class="normal-inline-box">
        <div class="max-long-input-box">
          <p class="box-title">{{$t("choosingAnEducationalInstitution")}}<span>*</span></p>
          <el-dropdown @command="handleCommandEducation">
                <span class="el-dropdown-link">
                  {{educationName}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item
                v-for="(item2,index) in educationData"
                :key="item2.userId"
                :command="item2"
              >{{item2.educationName}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>


        </div>
      </div>
      <!-- 第一二行 -->
      <div class="inline-box">
        <!-- 左边部分 -->
        <div class="one-box-left">
          <div class="Avatar">
            <div class="Avatar-img" @click="toGetImg" v-if="!image">
              <p class="Avatar-img-icon">
                <img src="./assets/Image_01.svg" alt="" />
              </p>
              <p class="Avatar-img-title">{{ $t("photograph") }}</p>
            </div>
            <div class="Avatar-img" @click="toGetImg" v-if="image">
              <img :src="image" alt="" class="Avatar-img-main-css" />
            </div>
          </div>
        </div>
        <!-- 右边部分 -->
        <div class="one-box-right">
          <div class="right-main-box">
            <div class="small-input-box">
              <p class="box-title">{{ $t("Fur") }}<span>*</span></p>
              <el-input v-model="anonym"></el-input>
            </div>
            <div class="small-input-box">
              <p class="box-title">
                {{ $t("employmentCharge") }}<span>*</span>
              </p>
              <el-dropdown @command="handleCommandPrincipal">
                <span class="el-dropdown-link">
                  {{ principal }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item2,index) in principalData"
                    :key="item2.userId"
                    :command="item2"
                  >{{item2.userName}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="right-main-box">
            <div class="small-input-box">
              <p class="box-title">{{ $t("familyName") }}<span>*</span></p>
              <el-input v-model="name" @blur="inputData(2)" maxlength="50"></el-input>
            </div>
            <div class="small-input-box">
              <p class="box-title">{{ $t("sex") }}<span>*</span></p>
              <el-dropdown  @command="handleCommand1" >
                <span class="el-dropdown-link">
                  {{ sex }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item1,index) in sexData"
                    :key="item1.code"
                    :command="item1"
                  >{{item1.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三行 -->
      <div class="normal-inline-box">
        <div class="small-input-box">
          <p class="box-title">{{ $t("telephoneNumber") }}<span>*</span></p>
          <el-input v-model="telephone"  @input="inputData(3)"  maxlength="20"></el-input>
        </div>
        <div class="long-input-box">
          <p class="box-title">{{ $t("email") }}<span>*</span></p>
          <el-input v-model="email"  @blur="inputData(4)"  maxlength="100"></el-input>
        </div>
      </div>
      <!-- 第四行 -->
      <div class="normal-inline-box">
        <div class="max-long-input-box">
          <p class="box-title">{{ $t("currentAddress") }}<span>*</span></p>
          <el-input v-model="address"  @blur="inputData(5)"  maxlength="100"></el-input>
        </div>
      </div>
      <!-- 第五行 -->
      <div class="normal-inline-box">
        <div class="max-long-input-box">
          <p class="box-title">{{ $t("birth") }}<span>*</span></p>
          <div class="block">
            <el-date-picker
              v-model="birth"
              type="date"
              @blur="dataTimeChange1"
              format="yyyy-MM-dd"
              :placeholder="$t('registerDayselsect')">
            </el-date-picker>
          </div>
        </div>
      </div>
      <!-- 第六行 -->
      <div class="normal-inline-box">
        <div class="small-input-box">
          <p class="box-title">{{ $t("japanese") }}<span>*</span></p>
          <el-dropdown @command="handleCommand2">
            <span class="el-dropdown-link">
              {{ japanese }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item2,index) in japaneseData"
                :key="item2.code"
                :command="item2"
              >{{item2.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="small-input-box">
          <p class="box-title">{{ $t("english") }}</p>
          <el-dropdown @command="handleCommand3">
            <span class="el-dropdown-link">
              {{ english }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item3,index) in englishData"
                :key="item3.code"
                :command="item3"
              >{{item3.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="small-input-box">
          <p class="box-title">{{ $t("other") }}</p>
          <el-input v-model="other"  @blur="inputData(6)"  maxlength="100"></el-input>
        </div>
      </div>
      <!-- 第七行 -->
      <div class="normal-inline-box">
        <div class="small-input-box">
          <p class="box-title">{{ $t("qualification1") }}</p>
          <el-input v-model="qualification1"  @blur="inputData(7)"  maxlength="100"></el-input>
        </div>
        <div class="small-input-box">
          <p class="box-title">{{ $t("qualification2") }}</p>
          <el-input v-model="qualification2"  @blur="inputData(8)"  maxlength="100"></el-input>
        </div>
        <div class="small-input-box">
          <p class="box-title">{{ $t("qualification3") }}</p>
          <el-input v-model="qualification3"  @blur="inputData(9)"  maxlength="100"></el-input>
        </div>
      </div>
      <!-- 第八行 -->
      <div class="label-line-box">
        <div
          :class="label1 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(1)"
        >
          {{ $t("goodAtJapanese") }} <span @click.stop="labelDel(0)">×</span>
        </div>
        <div
          :class="label2 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(2)"
        >
          {{ $t("qualified") }} <span @click.stop="labelDel(1)">×</span>
        </div>
        <div
          :class="label3 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(3)"
        >
          {{ $t("interviewAtAnytime") }}
          <span @click.stop="labelDel(2)">×</span>
        </div>
        <div
          :class="label4 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(4)"
        >
          {{ $t("determined") }} <span @click.stop="labelDel(3)">×</span>
        </div>
      </div>
      <!-- 第九行 -->
      <div class="biggest-inline-box">
        <p class="box-title">{{ $t("selfPR") }}<span>*</span></p>
        <el-input v-model="pr" type="textarea"  @blur="inputData(10)" maxlength="255"></el-input>
      </div>
      <!-- button 部分 -->
      <div class="line-button-box">
<!--        <button class="button-css1" @click="saveClick" :disabled="isLock">{{ $t("temporarilySaved") }}</button>-->
        <button class="button-css2" @click="nextClick">{{ $t("next") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import {eduAdminQueryUsers, educationInfoQuery, queryAppointInsAllUser, adminResumeAdd} from "../../js/api";
import axios from "axios";
import AES from "../../js/AES";

export default {
  name: "adminTalentAdd1",
  components: {},
  data() {
    return {
      isLock:false,
      avatar: "",//写真
      anonym: "", //フリガナ
      dropdown1: "", //就職担当
      name: "", //氏名
      sex: "", //性別
      telephone: "", //電話番号
      email: "", //メール
      address: "", //現住所
      birth: "", //出生月日
      japanese: "", //日本語
      english: "", //英語
      other: "", //その他
      qualification1: "", //資格1
      qualification2: "", //資格2
      qualification3: "", //資格3
      label1: 0,
      label2: 0,
      label3: 0,
      label4: 0,
      pr: "", //自己PR
      labelListHandle: [],
      hopeForm1: 0,//希望雇用形态1
      hopeForm2: 0,//
      hopeForm3: 0,//
      hopeForm4: 0,//

      sexData:[],
      inputData1:"",
      japaneseData:[],
      inputData2:"",
      englishData:[],
      inoutData3:"",
      principal: "", //採用担当
      principalData:[],
      avatarUrl:"",
      image:"",
      school:"",
      dataItem1:"",
      dataItem2:"",
      dataItem3:"",
      judgeContinue: false,
      userId:"",
      educationName:"" ,
      educationData:[],
      pageNumber: 1,
      pageSize: 10,
    };
  },

  computed: {},
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  created(){
    this.language = window.localStorage.getItem('language');
    console.log(this.language,"语言")
    this.getLanguage1();
    this.getLanguage2();
    this.getLanguage3();
    this.getSex();
    this.getJapanese();
    this.getEnglish();
    this.showUser();
    this.getEducationInfoQuery();
    if(JSON.stringify(this.$route.params)!=='{}'){
  console.log('第一页数据created',this.$route.params);
  this.educationName=this.$route.params.educationName
  this.educationId=this.$route.params.educationId
  this.principal=this.$route.params.principal;
      this.userId=this.$route.params.userId;
    this.avatar=this.$route.params.avatar
    this.anonym=this.$route.params.anonym
    this.name=this.$route.params.name
    this.sex=this.$route.params.sex
    this.telephone=this.$route.params.telephone
    this.email=this.$route.params.email
    this.address=this.$route.params.address
    this.birth=this.$route.params.birth
    this.japanese=this.$route.params.japanese
    this.english=this.$route.params.english
    this.other=this.$route.params.other
    this.qualification1=this.$route.params.qualification1
    this.qualification2=this.$route.params.qualification2
    this.qualification3=this.$route.params.qualification3
    this.pr=this.$route.params.pr
    this.label1=this.$route.params.label1
    this.label2=this.$route.params.label2
    this.label3=this.$route.params.label3
    this.label4=this.$route.params.label4

    this.enrollment=this.$route.params.enrollment
    this.graduation=this.$route.params.graduation
    this.education=this.$route.params.education
    this.school=this.$route.params.school
    this.profession=this.$route.params.profession
    this.startYear=this.$route.params.startYear
    this.endYear=this.$route.params.endYear
    this.workPlace=this.$route.params.workPlace
    this.type=this.$route.params.type
    this.hopeWorkplace=this.$route.params.hopeWorkplace
    this.hopeEntryTime=this.$route.params.hopeEntryTime
    // this.hopeForm1=this.$route.params.hopeForm1
    // this.hopeForm2=this.$route.params.hopeForm2
    // this.hopeForm3=this.$route.params.hopeForm3
    // this.hopeForm4=this.$route.params.hopeForm4
    this.startSalary=this.$route.params.startSalary
    this.endSalary=this.$route.params.endSalary
    this.otherHope=this.$route.params.otherHope
    this.userId=this.$route.params.userId
    this.inputData1=this.$route.params.inputData1
    this.inputData2=this.$route.params.inputData2
    this.inputData3=this.$route.params.inputData3
    this.inputData4=this.$route.params.inputData4
    this.inputData5=this.$route.params.inputData5
    this.inputData6=this.$route.params.inputData6

    this.avatarUrl=this.$route.params.avatarUrl

  }
  },
  activated(){
    if(JSON.stringify(this.$route.params)!=='{}'){
  console.log('第一页数据createdactivated',this.$route.params);
  this.educationName=this.$route.params.educationName
  this.educationId=this.$route.params.educationId
  this.principal=this.$route.params.principal;
      this.userId=this.$route.params.userId;
    this.avatar=this.$route.params.avatar
    this.anonym=this.$route.params.anonym
    this.name=this.$route.params.name
    this.sex=this.$route.params.sex
    this.telephone=this.$route.params.telephone
    this.email=this.$route.params.email
    this.address=this.$route.params.address
    this.birth=this.$route.params.birth
    this.japanese=this.$route.params.japanese
    this.english=this.$route.params.english
    this.other=this.$route.params.other
    this.qualification1=this.$route.params.qualification1
    this.qualification2=this.$route.params.qualification2
    this.qualification3=this.$route.params.qualification3
    this.pr=this.$route.params.pr
    this.label1=this.$route.params.label1
    this.label2=this.$route.params.label2
    this.label3=this.$route.params.label3
    this.label4=this.$route.params.label4

    this.enrollment=this.$route.params.enrollment
    this.graduation=this.$route.params.graduation
    this.education=this.$route.params.education
    this.school=this.$route.params.school
    this.profession=this.$route.params.profession
    this.startYear=this.$route.params.startYear
    this.endYear=this.$route.params.endYear
    this.workPlace=this.$route.params.workPlace
    this.type=this.$route.params.type
    this.hopeWorkplace=this.$route.params.hopeWorkplace
    this.hopeEntryTime=this.$route.params.hopeEntryTime
    // this.hopeForm1=this.$route.params.hopeForm1
    // this.hopeForm2=this.$route.params.hopeForm2
    // this.hopeForm3=this.$route.params.hopeForm3
    // this.hopeForm4=this.$route.params.hopeForm4
    this.startSalary=this.$route.params.startSalary
    this.endSalary=this.$route.params.endSalary
    this.otherHope=this.$route.params.otherHope
    this.userId=this.$route.params.userId
    this.inputData1=this.$route.params.inputData1
    this.inputData2=this.$route.params.inputData2
    this.inputData3=this.$route.params.inputData3
    this.inputData4=this.$route.params.inputData4
    this.inputData5=this.$route.params.inputData5
    this.inputData6=this.$route.params.inputData6

    this.avatarUrl=this.$route.params.avatarUrl

  }
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        that.getLanguage1();
        that.getLanguage2();
        that.getLanguage3();
        that.getSex();
        that.getJapanese();
        that.getEnglish();
        that.showUser();
        that.getEducationInfoQuery();
      }
    },
    // input校验
    inputData(num) {
      var vc = /^.{1,19}$/;
      var vc2 = /^.{1,49}$/;
      var vc3 = /^.{1,99}$/;
      var vc4 = /^.{1,254}$/;


      if (num === 1) {
        if(this.anonym.length<=0){
          this.$message({
            message:this.$t('dataEmpty'),
            type:'warning'
          });
        }else if (!vc2.test(this.anonym)) {
          this.$message({
            message:this.$t('waringAnonym'),
            type:'warning'
          });
        }
      }else if (num === 2) {
        if(this.name.length<=0){
          this.$message({
            message:this.$t('dataEmpty'),
            type:'warning'
          });
        }else if (!vc2.test(this.name)) {
          this.$message({
            message:this.$t('waringName'),
            type:'warning'
          });
        }
      } else if (num === 3) {
        if(this.telephone.length<=0){
          this.$message({
            message:this.$t('dataEmpty'),
            type:'warning'
          });
        }else if (!vc.test(this.telephone)) {
          this.$message({
            message:this.$t('waringTelephone'),
            type:'warning'
          });
        }
      } else if (num === 4) {
        if(this.email.length<=0){
          this.$message({
            message:this.$t('dataEmpty'),
            type:'warning'
          });
        }else if (!vc3.test(this.email)) {
          this.$message({
            message:this.$t('waringEmail'),
            type:'warning'
          });
        }
      } else if (num === 5) {
        if(this.address.length<=0){
          this.$message({
            message:this.$t('dataEmpty'),
            type:'warning'
          });
        }else if (!vc3.test(this.address)) {
          this.$message({
            message:this.$t('waringAddress'),
            type:'warning'
          });
        }
      } else if (num ===6 ) {
        if (!vc3.test(this.other)) {
          this.$message({
            message:this.$t('waringOther'),
            type:'warning'
          });
        }
      } else if (num ===7 ) {
        if (!vc3.test(this.qualification1)) {
          this.$message({
            message:this.$t('waringQualification1'),
            type:'warning'
          });
        }
      } else if (num === 8) {
        if (!vc3.test(this.qualification2)) {
          this.$message({
            message:this.$t('waringQualification2'),
            type:'warning'
          });
        }
      } else if (num === 9) {
        if (!vc3.test(this.qualification3)) {
          this.$message({
            message:this.$t('waringQualification3'),
            type:'warning'
          });
        }
      } else if (num === 10) {
        if(this.pr.length<=0){
          this.$message({
            message:this.$t('dataEmpty'),
            type:'warning'
          });
        }else if (!vc4.test(this.pr)) {
          this.$message({
            message:this.$t('waringPr'),
            type:'warning'
          });
        }
      }

    },
    //教育机构查询
    getEducationInfoQuery() {
      var dto={
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      }
      educationInfoQuery(dto).then((res) => {
        console.log("---教育机构查询----")
        console.log(res)
        if (res.data.code === "A0000") {
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
          console.log(aesFecInfo)
          this.educationData=aesFecInfo.data
        }
      }).catch((res) => {
        console.log("----教育机构查询接口异常----")
        console.log(res)
      })
    },
    handleCommandEducation(evt){
      this.educationName=evt.educationName
      this.educationId=evt.educationId
      this.showUser();
    },
    getLanguage1(){
      if(this.language === "CN"){
        this.dataItem1 = "sex"
      }
      else {
        this.dataItem1 = "jpsex"
      }
    },
    getLanguage2(){
      if(this.language === "CN"){
        this.dataItem2 = "japanese"
      }
      else {
        this.dataItem2 = "jpjapanese"
      }
    },
    getLanguage3(){
      if(this.language === "CN"){
        this.dataItem3 = "english"
      }
      else {
        this.dataItem3 = "jpenglish"
      }
    },
    //获取担当人信息
    showUser(){
      var dto = {
        educationId: this.educationId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      }
      queryAppointInsAllUser(dto).then((res) => {
        console.log("---查询当前机构下的人才信息----")
        console.log(res)
        if (res.data.code === "A0000") {
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
          console.log(aesFecInfo.data)
          console.log("11111")
          this.principalData=aesFecInfo.data
        }
      }).catch((res) => {
        console.log("----查询当前机构下的人才信息失败----")
        console.log(res)
      })
    },
    selectUserClick(userName){
      this.principal=userName;
    },
    //性别下拉框
    getSex(){
      var that=this;
      that.getLanguage1();
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.dataItem1
          },
          headers:{
            'content-type': 'application/x-www-form-urlencoded',
            "token":localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if(res.data.code === "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.sexData=aesFecInfo.data;
            console.log(that.sexData);
          }else{
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleCommand1(evt){
      this.inputData1=evt.code;
      this.sex=evt.name;
      console.log(evt);
    },
    //日语下拉框
    getJapanese(){
      var that=this;
      that.getLanguage2();
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.dataItem2
          },
          headers:{
            'content-type': 'application/x-www-form-urlencoded',
            "token":localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if(res.data.code === "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.japaneseData=aesFecInfo.data;
            console.log(that.japaneseData);
          }else{
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleCommand2(evt){
      this.inputData2=evt.code;
      this.japanese=evt.name;
      console.log(evt);
    },
    handleCommandPrincipal(evt){
      this.principal=evt.userName;
      this.userId=evt.userId;
    },
    //英语下拉框
    getEnglish(){
      var that=this;
      that.getLanguage3();
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.dataItem3
          },
          headers:{
            'content-type': 'application/x-www-form-urlencoded',
            "token":localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if(res.data.code === "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.englishData=aesFecInfo.data;
            console.log(that.englishData);
          }else{
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleCommand3(evt){
      this.inputData3=evt.code;
      this.english=evt.name;
      console.log(evt);
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("日本語上手") === -1) {
            this.labelListHandle.push("日本語上手");
          }
          this.label1 = 1;
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("資格あり") === -1) {
            this.labelListHandle.push("資格あり");
          }
          this.label2 = 1;
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("随時面接") === -1) {
            this.labelListHandle.push("随時面接");
          }
          this.label3 = 1;
        } else {
          if (this.labelListHandle.indexOf("決心あり") === -1) {
            this.labelListHandle.push("決心あり");
          }
          this.label4 = 1;
        }
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 0) {
        this.label1 = 0;
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "日本語上手") {
            this.labelListHandle.splice(i, 1);
          }
        }
      } else if (num === 1) {
        this.label2 = 0;
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "資格あり") {
            this.labelListHandle.splice(i, 1);
          }
        }
      } else if (num === 2) {
        this.label3 = 0;
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "随時面接") {
            this.labelListHandle.splice(i, 1);
          }
        }
      } else if (num === 3) {
        this.label4 = 0;
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "決心あり") {
            this.labelListHandle.splice(i, 1);
          }
        }
      }
      console.log(this.labelListHandle);
    },
    //上传图片
    toGetImg() {
      let inputElement = null;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }
        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 2;
        const size = files.size / 1024 / 1024;
        console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$message.error(this.$t("imageSize"));
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$message.error(this.$t("selectImage"));
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function () {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.image = this.result;
            console.log(this.result);
            // 数据传到后台
            const formData = new FormData();
            formData.append("file", files); // 可以传到后台的数据
            console.log(formData.get("file"));
            axios
              .post("/api/modules-parent/upload/uploadPictureToOSS", formData, {
                headers: {
                  //头部参数
                  "Content-Type": "multipart/form-data",
                  token: localStorage.getItem("token")
                }
              })
              .then(function (res) {
                //请求成功
                if (res.data.code === "200 OK") {
                  console.log("-----上传图片参数-----");
                  console.log(res);
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                  console.log(aesFecInfo);
                  that.avatar = aesFecInfo.path;
                  that.avatarUrl = aesFecInfo.url;
                  console.log(that.avatar)
                  console.log(that.avatarUrl)
                }
              })
              .catch(function (error) {
                //请求失败
                console.log(error);
              });
          };
        }
      }
    },
    dataTimeChange1() {
      this.birth = this.timeJs(this.birth)
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = ' 星期' + '日一二三四五六'.charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes()
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d;
    },
    judgeData(){
      if(this.anonym === "" || this.principal === "" || this.name === ""
        || this.sex === "" || this.telephone === "" || this.email === ""
        || this.address === "" || this.birth === "" || this.japanese === ""
        || this.pr === "") {
        this.$message({
          message: this.$t("dataEmpty"),
          type: 'warning'
        });
        this.judgeContinue = true;
      }
      else {
        this.judgeContinue = false;
      }
    },
    nextClick(){
      console.log("下一步");
      this.judgeData();
      if(this.judgeContinue === false) {
        this.$router.push({
          path: '/adminTalentAdd2',
          name: 'adminTalentAdd2',
          params: {
            educationName:this.educationName,
            educationId:this.educationId,
            principal:this.principal,
            avatar: this.avatar,//写真
            anonym: this.anonym,//假名-----1
            //就职担当
            name: this.name,//姓名------1
            userId: this.userId,
            sex: this.sex,//性别---1
            telephone: this.telephone,//电话
            email: this.email,//邮箱
            address: this.address,//现居住地
            birth: this.birth,
            japanese: this.japanese,//日本语
            english: this.english,//英语
            other: this.other,//其他
            qualification1: this.qualification1,//资格1
            qualification2: this.qualification2,
            qualification3: this.qualification3,
            pr: this.pr,//自己pr--------1
            label1: this.label1,
            label2: this.label2,
            label3: this.label3,
            label4: this.label4,
            inputData1: this.inputData1,
            inputData2: this.inputData2,
            inputData3: this.inputData3,
            avatarUrl: this.avatarUrl
          }
        });
      }
    },
    saveClick(){
      this.judgeData();
      this.isLock = true;
      if(this.judgeContinue === false) {
        var fakeInfo = {
          avatar: this.avatar,//写真
          anonym: this.anonym,//假名-----1
          //就职担当
          name: this.name,//姓名------1
          userId: this.userId,
          sex: this.inputData1,//性别---1
          telephone: this.telephone,//电话
          email: this.email,//邮箱
          address: this.address,//现居住地
          birth: this.birth, //出生年月--1
          japanese: this.inputData2,//日本语
          english: this.inputData3,//英语
          other: this.other,//其他
          qualification1: this.qualification1,//资格1
          qualification2: this.qualification2,
          qualification3: this.qualification3,
          pr: this.pr,//自己pr--------1
          label1:this.label1,
          label2:this.label2,
          label3:this.label3,
          label4:this.label4,
          enrollment: "",//入学年月---2
          graduation: "",//毕业年月---2
          school: "",//学校----2
          profession: "",//专业---2
          startYear: "",//开始年月
          endYear: "",//结束年月
          workPlace: "",//工作地点
          type: "",//所属
          hopeWorkplace: "",//希望工作地点
          hopeEntryTime: "",//希望工作时间
          hopeWorkType: "",//希望工作类型
          hopeForm1: 0,//希望雇用形态1
          hopeForm2: 0,//
          hopeForm3: 0,//
          hopeForm4: 0,//
          hopeSalary: "",//希望工资
          startSalary: 0,//开始工资
          endSalary: 0,//结束工资
          otherHope: "",//其他希望

          education: "",//学历--？
          resumeId: "",//人才ID

        }
        adminResumeAdd(fakeInfo).then((res) => {
          console.log("人才信息添加保存接口");
          console.log(res);
          if(res.data.code === "A0000"){
            this.isLock = false;
            this.$message({
              message: this.$t("saveSuccess"),
              type: 'success'
            });
            this.$router.push("/educationalInstitutionTalentListView");
          }
          else{
            this.$message.error(this.$t("saveFail"));
          }
        })
      }
    },
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  min-height: 950px;
}
.main-box {
  width: 700px;
  height: 100%;
  margin: 0 auto;
  background: #fff;
}
.top-title {
  margin-top: 10px;
  height: 30px;
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
}
.progress-bar {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
.line-between-active {
  height: 2px;
  width: 80px;
  background: #51abff;
}
.line-between-normal {
  height: 2px;
  width: 80px;
  background: #dce3e9;
}
.line-center-normal {
  height: 2px;
  width: 160px;
  background: #dce3e9;
}

.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}
.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #000;
  position: relative;
}
.progress-title {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -75px;
  display: block;
  height: 24px;
  width: 150px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #252a31;
}
.inline-box {
  height: 110px;
  width: 700px;
  margin-top: 10px;
  display: flex;
}
.one-box-left {
  width: 200px;
  height: 110px;
  padding-left: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.one-box-right {
  flex: 1;
  margin-left: 50px;
}
.right-main-box {
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
}
.small-input-box {
  width: 180px;
  height: 42px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 27px;
}
.box-title {
  padding: 0 5px;
  background: #ffffff;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  height: 24px;
  color: #51abff;
  position: absolute;
  top: -14px;
  left: 10px;
  z-index: 10;
}
.box-title span {
  font-weight: 600;
  font-size: 11px;
  line-height: 24px;
  color: #da1414;
  opacity: 0.8;
  margin-left: 2px;
}
.small-input-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  width: 170px;
  height: 38px;
  margin-left: 2px;
}
.small-input-box /deep/ .el-dropdown {
  margin-left: 2px;
  width: 170px;
  height: 38px;
  line-height: 38px;
  padding-left: 10px;
  box-sizing: border-box;
}
.small-input-box /deep/ .el-dropdown-link {
  width: 155px;
  height: 38px;
  display: inline-block;
}
.small-input-box /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.normal-inline-box {
  height: 45px;
  width: 100%;
  margin-top: 15px;
  display: flex;
  align-items: center;
  padding-left: 40px;
  box-sizing: border-box;
}
/*.Education-box /deep/ .el-icon--right{*/
/*  !*margin-left: 570px;*!*/
/*  float: right;*/
/*}*/
/*.Education-box /deep/ .el-icon-arrow-down {*/
/*  float: right;*/
/*  line-height: 38px;*/
/*}*/
.normal-inline-box /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.long-input-box {
  width: 389px;
  height: 42px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.long-input-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  width: 380px;
  height: 38px;
  margin-left: 2px;
}
.max-long-input-box {
  width: 598px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  height: 42px;
  position: relative;
  margin-right: 27px;
}
.max-long-input-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  width: 590px;
  height: 38px;
  margin-left: 2px;
}
.max-long-input-box /deep/ .el-dropdown {
  margin-left: 2px;
  width: 590px;
  height: 38px;
  line-height: 38px;
  padding-left: 10px;
  box-sizing: border-box;
}
.max-long-input-box /deep/ .el-dropdown-link {
  width: 575px;
  height: 38px;
  display: inline-block;
}
.max-long-input-box /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.normal-inline-box .small-input-box {
  margin-right: 30px;
}

.label-line-box {
  width: 700px;
  height: 44px;
  margin: 0 auto;
  padding-left: 40px;
  box-sizing: border-box;
  margin-top: 15px;
}
.label-box {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.biggest-inline-box {
  width: 598px;
  height: 135px;
  border: 2px solid #b2b2b2;
  margin-left: 40px;
  margin-top: 15px;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}

.biggest-inline-box /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  width: 590px;
  height: 120px;
  margin-left: 2px;
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.button-css1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 18px;
  color: #fff;
}

.Avatar {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Avatar-img {
  width: 90px;
  height: 90px;
  background: #51abff;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
}
.Avatar-img-icon {
  margin-top: 15px;
}
.Avatar-img-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.Avatar-img .Avatar-img-main-css {
  width: 90px;
  height: 90px;
}


.block /deep/ .el-input, .el-date-editor.el-input__inner {
  width: 155px;
}

.normal-inline-box /deep/ .el-input__suffix{
  right: -370px;
}
.el-input.is-disabled .el-input__inner {
  background-color: #F5F7FA;
  border-color: rgb(255 255 255 / 50%);
  color: #4a4a49;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/pages/adminTalentAdd1/index.vue